import { useMutation } from "react-query";
import Angie from "~/utils/angie";
import { fetch } from "~/utils/fetch";

export const useAnalyzeExpenseFile = (projectId) => {
  return useMutation({
    mutationFn: (data) =>
      fetch({
        url: `${Angie.api_url}/projects/${projectId}/expenses/analyze-file`,
        method: "POST",
        body: data,
      }),
  });
};
